<template>
    <span>
        <button
            type="button"
            class="align-middle"
            :title="lang('Radera','Delete')"
            @click="$modal.show(`remove-email-account-alias-${emailAccount.id}-${alias}`)"
        >
            <font-awesome-icon :icon="['fal', 'times']" class="text-danger mr-xs" />
        </button>

        <form-modal
            :title="lang('Ta bort alias','Delete alias')"
            :name="`remove-email-account-alias-${emailAccount.id}-${alias}`"
            method="delete"
            :action="route('front.my-pages.api.email-accounts.aliases.destroy', [emailAccount, alias])"
            :callback="handleResponse"
            :hide-when-done="true"
            :primary-button-text="lang('Spara','Save')"
            :close-button-text="lang('Avbryt','Cancel')"
        >
            <p>
                {{ lang('Vill du verkligen ta bort aliaset','Are you sure you want to delete the alias') }}?
            </p>
        </form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            emailAccount: {
                type: Object,
                required: true,
            },
            alias: {
                type: String,
                required: true,
            },
        },

        methods: {
            handleResponse(response) {
                flash_success(lang('Aliaset borttaget.', 'The alias was removed.'));

                this.$emit('aliasRemoved', response.data);
            },
        },
    };
</script>
